"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedCards = void 0;
var vue_1 = require("vue");
var Card_1 = require("./card/Card");
exports.StackedCards = vue_1.default.component('stacked-cards', {
    props: {
        cards: {
            type: Array,
        },
    },
    components: {
        Card: Card_1.Card,
    },
    methods: {},
    template: "\n    <div class=\"cardbox\">\n        <div v-for=\"(card, index) in cards\" :key=\"card.name\" :class=\"{'cards-stack':(index > 0),'cards-stack-first':(index === 0) }\">\n            <Card :card=\"card\" />\n        </div>\n    </div>\n    ",
});
//# sourceMappingURL=StackedCards.js.map